import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b4583ae&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4583ae')) {
      api.createRecord('5b4583ae', component.options)
    } else {
      api.reload('5b4583ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b4583ae&", function () {
      api.rerender('5b4583ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_listary_landing/components/AppMore/index.vue"
export default component.exports